import React, { useState, FormEvent } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authService } from '../services';
import { Button, Input } from '../components/common';
import './ForgotPasswordPage.css';

export const ForgotPasswordPage: React.FC = () => {
  const [username, setUsername] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage(null);

    if (!username.trim()) {
      setError('Please enter your username');
      return;
    }

    setIsLoading(true);
    try {
      await authService.forgotPassword(username);
      setSuccessMessage('Verification code sent to your email!');
      // Navigate to reset password page after a short delay
      setTimeout(() => {
        navigate('/reset-password', { state: { username } });
      }, 1500);
    } catch (err: any) {
      if (err.name === 'UserNotFoundException') {
        setError('User not found. Please check your username.');
      } else if (err.name === 'LimitExceededException') {
        setError('Too many attempts. Please try again later.');
      } else {
        setError(err.message || 'Failed to send reset code. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-container">
        <div className="forgot-password-header">
          <h1 className="forgot-password-title">Forgot Password</h1>
          <p className="forgot-password-subtitle">
            Enter your username and we'll send a verification code to your email
          </p>
        </div>

        <form className="forgot-password-form" onSubmit={handleSubmit}>
          {error && <div className="forgot-password-error">{error}</div>}
          {successMessage && <div className="forgot-password-success">{successMessage}</div>}

          <Input
            label="Username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Enter your username"
            fullWidth
            required
          />

          <Button
            type="submit"
            variant="primary"
            fullWidth
            isLoading={isLoading}
          >
            Send Reset Code
          </Button>
        </form>

        <div className="forgot-password-footer">
          <p>
            Remember your password?{' '}
            <Link to="/login" className="forgot-password-link">
              Back to Login
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};
